export default "__VITE_ASSET__BRs53_Qr__"